class GoogleAnalytics {
  static openPage() {
    // console.log('Google Analytics não está disponível.', page, title);
    // if (process.env.NODE_ENV === 'production') {
    //   console.log('Google Analytics não está disponível.');
    //   if (window.$gtag) {
    //     window.$gtag.pageview({
    //       page_path: page,
    //       page_title: title,
    //       page_location: window.location.href
    //     });
    //   } else {
    //     console.warn('Google Analytics não está disponível.');
    //   }
    // }
  }

  static event() {
    if (process.env.NODE_ENV === 'production') {
      console.log('Google Analytics não está disponível.');
    //   if (window.$gtag) {
    //     window.$gtag.event(action, {
    //       event_category: category,
    //       event_label: label,
    //       value: value
    //     });
    //   } else {
    //     console.warn('Google Analytics não está disponível.');
    //   }
    }
  }
}

export default GoogleAnalytics;